module.exports = __webpack_public_path__ + "static/media/blaine-intro-3.5be15944.wav";